import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
// import pdf from "../../Assets/rithiksamanthularesume.pdf";

function Resume() {
  const uri = "https://porfolio-backend.vercel.app/ranks/getRanks";
  const [spojRank, upadteSpojRank] = useState(0);
  const [hackerrank, upadteHackerank] = useState(0);
  const [sem, upadateSem] = useState(0);
  const [cgpa, upadteCgpa] = useState(0);

  useEffect(() => {
    axios
      .get(uri)
      .then((res) => {
        upadteSpojRank(res.data.message[0].spojRank);
        upadteHackerank(res.data.message[1].hackerrank);
        upadteCgpa(res.data.message[2].cgpa);
        upadateSem(res.data.message[3].sem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Container fluid className="resume-section" id="resume">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href="https://drive.google.com/file/d/1An6VNtvk2xlxyjmxYZGFptSpUlKnZPzD/view?usp=sharing" target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="SDE Backend Intern - INNOVACCER"
              date="May'2021 - July'2021"
              content={[
                "Worked on a live project, created API’s and worked on firebase push notifications.",
                "Developed a full stack web application using Django, HTML, CSS , SQlite.",
              ]}
            />
            {/* <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Service as Action - Local Buisness"
              content={[
                "Did Service as Action for a Local Buisness and helped them get an online presence",
              ]}
            />
            <Resumecontent
              title="Service as Action - Phoenix United"
              content={[
                "Did Service as Action for a Phoenix United which is a youtube gaming community and helped them get an online presence as well.",
              ]}
            /> */}
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="National Institute of Technology, Hamirpur"
              date="B-Tech. 2018 - 2022"
              content={[]}
            />
            <Resumecontent
              title="Minerva Sr. Sec. School Ghumarwin"
              date="Intermediate 2015 - 2017"
              content={[]}
            />
            {/* <h3 className="resume-title">Badges and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                `🏅 4 Week Streak Badge 🏅 -  Awarded for consistency of writing.`,
                `Computer Student of the Year`,
              ]}
            /> */}
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
